var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 189,
    viewBox: "0 0 190 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 94.5,
    r: 94.5,
    fill: "url(#paint0_linear_236_10014)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.091 102.513L116.5 96.9208C115.17 95.775 114.391 94.0792 114.345 92.2C114.254 90.1375 115.079 88.075 116.591 86.5625L122.091 81.0625C126.858 76.2958 128.645 71.7125 127.133 68.0917C125.666 64.5167 121.129 62.5458 114.437 62.5458H66.5413V58.6042C66.5413 56.725 64.9829 55.1667 63.1038 55.1667C61.2246 55.1667 59.6663 56.725 59.6663 58.6042V143.396C59.6663 145.275 61.2246 146.833 63.1038 146.833C64.9829 146.833 66.5413 145.275 66.5413 143.396V121.029H114.437C121.037 121.029 125.483 119.013 126.995 115.392C128.508 111.771 126.766 107.233 122.091 102.513Z",
    fill: "#206648"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_236_10014",
    x1: 34.2148,
    y1: 44.543,
    x2: 189.5,
    y2: 189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57BD47",
    stopOpacity: 0.45
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.8393cbe29d5050f16423a3b0d9d7e2fd.svg";
export { ForwardRef as ReactComponent };